import React from 'react';
import Aux from '../Hoc/Aux';

import iconCheck from '../../assets/svg/icon-check.svg';
import iconCheckup from '../../assets/svg/icon-checkup.svg';
import iconPenny from '../../assets/svg/icon-penny.svg';
import iconOnline from '../../assets/svg/icon-online.svg';
import iconGym from '../../assets/svg/icon-gym.svg';
import iconGym02 from '../../assets/svg/icon-gym-02.svg';
import iconHospital from '../../assets/svg/icon-hospital.svg';
import iconNational from '../../assets/svg/icon-national.svg';
import iconHeartrate from '../../assets/svg/icon-heartrate.svg';
import iconLifePoints from '../../assets/svg/icon-pocket.svg';
import iconWeightManagement from '../../assets/svg/icon-weight-management.svg';
// import iconCovered from '../../assets/svg/icon-covered.svg';
// import iconGlobal from '../../assets/svg/icon-global.svg';
// import iconAward from '../../assets/svg/icon-award1.svg';
// import iconTravel from '../../assets/svg/icon-travel.svg';
// import iconHeartrate from '../../assets/svg/icon-heartrate.svg';
import iconCovered from '../../assets/svg/icon-covered.svg';
// import iconOTC from '../../assets/svg/icon-otc.svg';
import iconMedicareDental from '../../assets/svg/icon-medicare-dental.svg';
import iconMedicareVision from '../../assets/svg/icon-medicare-vision.svg';
// import iconMedicareOTC from '../../assets/svg/icon-medicare-otc.svg';

// import iconInOut from '../../assets/svg/icon-in-out.svg';
import iconPapaPals from '../../assets/svg/icon-papa-pals-02.svg';

const reasons = (props) => {
  const findADoc = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'Click',
      'eventAction': 'Load Website',
      'eventLabel': 'Find a Doc',
      'eventValue': undefined
    });
  };

  const introVar = props.intro;
  let intro;
  if (introVar) {
    if (introVar === 'true') {
      intro = <h2>A few reasons why you&rsquo;ll&nbsp;love&nbsp;us.</h2>;
    } else {
      intro = <h2>{introVar}</h2>;
    }
  }
  const padding = (props.intro === 'true') ? 'p60' : '';
  let divide = (props.divide) ? props.divide : '';
  let colNum = (props.colNum) ? props.colNum : '';

  let iconList;
  let searchLink = (props.search) ? props.search : 'https://findadoc.cdphp.com/';

  let national = (<li className='col'>
    <span><img src={iconNational} alt='Coverage from coast to coast, including at all the top hospitals' /></span>
    <p>Coverage from coast to coast,<br /> including at all the top hospitals</p>
  </li>);

  let hospital = (<li className='col'>
    <span><img src={iconHospital} alt='Access to most local doctor and Hospitals' /></span>
    <p>Access to most local doctors<br /> and hospitals (<a
      href={searchLink}
      target='_blank'
      rel='noopener noreferrer'
      onClick={findADoc}
    >search now</a>)</p>
  </li>);

  let checkout = (<li className='col'>
    <span><img src={iconCheckup} alt='Checkups, flu shots, and other preventive care at no cost to you' /></span>
    <p>Checkups, flu shots, and other preventive care at no cost to you</p>
  </li>);

  let check = (<li className='col'>
    <span><img src={iconCheck} alt='Pre-existing conditions' /></span>
    <p>Coverage for any and all<br /> pre-existing conditions</p>
  </li>);

  let penny = (<li className='col'>
    <span><img src={iconPenny} alt='Penny Prescription' /></span>
    <p>Low-cost prescriptions (a dollar a fill for nearly <a href='https://www.cdphp.com/members/rx-corner/drug-coverage/rx-for-less' target='_blank' rel='noopener noreferrer'>100 common drugs</a>)</p>
  </li>);

  let online = (<li className='col'>
    <span><img src={iconOnline} alt='Ability to see a doctor online' /></span>
    <p>Ability to see a doctor online<br /> 24/7 from the comfort of home</p>
  </li>);

  let gym = (<li className='col'>
    <span><img src={iconGym} alt='Free fitness classes' /></span>
    <p>Free fitness classes to help<br /> you stay healthy</p>
  </li>);

  /*
  let topRated = (<li className='col'>
    <span><img src={iconAward} alt='Low, predictable copays' /></span>
    <p>Peace of mind with<br /> a top-rated Medicare plan*<sup>&dagger;</sup></p>
  </li>);

  let travel = (<li className='col'>
    <span><img src={iconTravel} alt='Worldwide coverage' className='travel' /></span>
    <p>Emergency care while<br /> traveling abroad</p>
  </li>);

  let countryGyms = (<li className='col'>
    <span><img src={iconGym} alt='14,000 gyms across the country' className='gyms' /></span>
    <p>Unlimited free access to over 14,000 gyms across the country</p>
  </li>);
  */

  let medicarePhysicals = (<li className='col'>
    <span><img src={iconHeartrate} alt='Physicals and preventive' /></span>
    <p>Physicals and preventive<br /> screenings at no cost to you</p>
  </li>);

  let essentialDental = (<li className='col'>
    <span><img src={iconCovered} alt='No cost dental and vision' /></span>
    <p>No cost dental and vision + expanded vision network</p>
  </li>);

  let essentialFitness = (<li className='col'>
    <span><img src={iconGym02} alt='Fitness reimbursement' /></span>
    <p>Fitness reimbursement,<br /> up to $400</p>
  </li>);

  let essentialWeight = (<li className='col'>
    <span><img src={iconWeightManagement} alt='Weight management reimbursement' /></span>
    <p>Weight management reimbursement, up to $75</p>
  </li>);

  let essentialLifePointsRewards = (<li className='col'>
    <span><img src={iconLifePoints} alt='CDPHP Life Points Rewards' /></span>
    <p>CDPHP Life Points Rewards for completing health-related activities, redeemable for gift cards and merchandise.</p>
  </li>);

  /*
  let medicareInOut = (<li className='col'>
    <span><img src={iconInOut} alt='In and Out of network' className='' /></span>
    <p>Flexibility to go in and out of network on PPO&nbsp;plans</p>
  </li>);
  */

  let medicareDental = (<li className='col'>
    <span><img src={iconMedicareDental} alt='Dental benefits' /></span>
    <p>Dental allowance on a prepaid benefits card to use at any dentist in&nbsp;the&nbsp;U.S.</p>
  </li>);

  let medicareVision = (<li className='col'>
    <span><img src={iconMedicareVision} alt='Vision benefits' /></span>
    <p>Money for eyeglasses and contact lenses now included on a prepaid benefits&nbsp;card</p>
  </li>);

  // let medicareOTC = (<li className='col'>
  //   <span><img src={iconMedicareOTC} alt='$50 for OTC products' className='' /></span>
  //   <p>Up to $100 per quarter on a prepaid benefits card for over-the-counter health care&nbsp;supplies</p>
  // </li>);

  // let medicareWNYOTC = (<li className='col'>
  //   <span><img src={iconOTC} alt='$50 for OTC products' className='' /></span>
  //   <p>$25 per quarter on a prepaid benefits card for over-the-counter health care&nbsp;supplies</p>
  // </li>);

  let medicarePrescription = (<li className='col'>
    <span><img src={iconPenny} alt='Prescription coverage starting' className='penny' /></span>
    <p>$0 prescriptions at preferred retail locations and through mail order for hundreds of&nbsp;medications</p>
  </li>);

  let medicareGym = (<li className='col'>
    <span><img src={iconGym} alt='15,000 gyms across the country' className='gyms' /></span>
    <p>Unlimited free access to over 15,000 gyms across the country plus online fitness&nbsp;classes</p>
  </li>);

  let medicarePapaPals = (<li className='col'>
    <span><img src={iconPapaPals} alt='Papa Pals' className='gyms' /></span>
    <p>Up to 60 hours of in-home support services from a trained Papa Pal</p>
  </li>);

  if (props.type === 'biz') {
    iconList = (
      <Aux>
        {national}
        {checkout}
        {check}
        {penny}
        {online}
        {gym}
      </Aux>
    );
  } else if (props.type === 'medicare') {
    iconList = (
      <Aux>
        {medicareDental}
        {medicarePhysicals}
        {medicarePapaPals}
        {medicareVision}
        {medicarePrescription}
        {medicareGym}
      </Aux>
    );
  } else if (props.type === 'medicareWNY') {
    iconList = (
      <Aux>
        {medicareDental}
        {medicarePhysicals}
        {medicarePapaPals}
        {medicareVision}
        {medicarePrescription}
        {medicareGym}
      </Aux>
    );
  } else if (props.type === 'essential') {
    iconList = (
      <Aux>
        {essentialFitness}
        {essentialWeight}
        {essentialLifePointsRewards}
        {checkout}
        {essentialDental}
        {online}
        {penny}
        {check}
        {hospital}
      </Aux>
    );
  } else {
    iconList = (
      <Aux>
        {hospital}
        {checkout}
        {check}
        {penny}
        {online}
        {gym}
      </Aux>
    );
  }

  return (
    <section className={divide + ' ' + padding}>
      <div className='wrap'>
        {intro}
        <ul className={'three-col reasons ' + colNum}>
          {iconList}
        </ul>
      </div>
    </section>
  );
};

export default reasons;



// WEBPACK FOOTER //
// ./src/components/Reasons/ReasonsResults.js